import { useState, useEffect } from "react";
import { Box, TextField, Button, Autocomplete } from "@mui/material";
import Detail from "../../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseMagLandings } from "../UseMagLandings";
import { useNavigate, useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function AddGroupLanding(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { GetArticleGroups, validateGroup, AddLandingGroup } = UseMagLandings();
  const navigate = useNavigate();
  const [articleGroups, setArticleGroups] = useState();
  const { isSmall } = useBreakpoints();
  const groupType = [
    { id: 1, title: "جدیدترین" },
    { id: 2, title: "محبوب ترین" },
    { id: 3, title: "پربازدید ترین" },
  ];

  const [state, setState] = useState({
    LandingID: location.state.thisOfferId,
    groupID: undefined,
    title: undefined,
    type: undefined,
  });

  const [errorState, setErrorState] = useState({
    title: false,
  });

  useEffect(() => {
    setProgress(true);
    GetArticleGroups((Articles) => {
      setArticleGroups(Articles.groups);
    });
  }, []);

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [
          {
            name: msActiveMenu.pageTitle,
            url: "/magmanagment",
          },
          {
            name: "مدیریت" + " " + location.state.componentFaTitle,
            url: "/magmanagment/LandingsManage",
            LandingID: location.state.LandingID && location.state.LandingID,
            componentFaTitle:
              location.state.componentFaTitle &&
              location.state.componentFaTitle,
          },
          {
            name: "افزودن گروه",
            url: "/magmanagment/LandingsManage/AddGroup",
          },
        ],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box
          // sx={{ border: "1px solid #E1E1E1", p: 2, borderRadius: 1 }}
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          gap={2}
        >
          <Box gridColumn={isSmall ? "span 12" : "span  3"}>
            <TextField
              fullWidth
              value={state.title ? state.title : ""}
              error={errorState.title}
              label="عنوان گروه"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, title: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span  3"}>
            {articleGroups && (
              <Autocomplete
                size="small"
                onChange={(event, newValue) => {
                  setState({ ...state, groupID: newValue });
                }}
                isOptionEqualToValue={(option, value) => {
                  return value == "" || option === value;
                }}
                getOptionLabel={(option) => {
                  if (option) {
                    return articleGroups?.find((m) => m.id == option)?.faName;
                  }
                  return "";
                }}
                options={articleGroups ? articleGroups.map((m) => m.id) : []}
                renderInput={(params) => (
                  <TextField
                    error={errorState.groupID}
                    variant="outlined"
                    {...params}
                    label="گروه مقاله"
                  />
                )}
              />
            )}
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span  3"}>
            <Autocomplete
              size="small"
              value={state.type ? state.type : ""}
              onChange={(event, newValue) => {
                setState({ ...state, type: newValue });
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return groupType.find((m) => m.id == option).title;
                }
                return "";
              }}
              fullWidth
              options={groupType.map((m) => m.id)}
              renderInput={(params) => (
                <TextField variant="outlined" {...params} label="نوع" />
              )}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span  3"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              onClick={() => {
                if (validateGroup(state, setErrorState) == 200) {
                  if (state.groupID && !state.type) {
                    enqueueSnackbar("لطفا نوع را وارد کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  if (state.type && !state.groupID) {
                    enqueueSnackbar("لطفا گروه مقاله را وارد کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  setProgress(true);
                  AddLandingGroup(state, (callback) => {
                    navigate("/magmanagment/LandingsManage", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
              color="secondary"
              sx={{ mr: 1, width: "80px" }}
              variant="contained"
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "80px" }}
              onClick={() => {
                navigate("/magmanagment/LandingsManage", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
              color="secondary"
              variant="outlined"
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      </Box>
    </Detail>
  );
}
